import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./accessDenied.module.scss";
import { withTranslation } from "react-i18next";
import FordLogo from "../../common/FordLogo";
import { invalidateSession } from "../../common/InvalidateSession";
import { IS_CANADA_MARKET, IS_USA_MARKET } from "../../utils/EmpUtil";
import { LANGUAGE_MARKET_MAP } from "../../common/Constants";

class AccessDeniedAsBevDisabled extends Component {
  componentDidMount() {
    const { userDetails, i18n, history } = this.props;
    const market = userDetails?.market;

    if (!(IS_USA_MARKET(market) || IS_CANADA_MARKET(market))) {
      const language = LANGUAGE_MARKET_MAP[market];

      if (language) {
        i18n.changeLanguage(`${language.substring(0, 2)}_${market}`);
      }
    }

    history.push("/denied");
    invalidateSession();
  }

  render() {
    const { market, t } = this.props;
    const isUsaOrCanadaMarket = IS_USA_MARKET(market) || IS_CANADA_MARKET(market);

    return (
      <div className="pageWrapper">
        <div className={styles.brandDiv}>
          <FordLogo className={styles.brandLogo} />
        </div>
        <div className={styles.deniedTitle}>
          {isUsaOrCanadaMarket
            ? t("AccessDeniedAsBevDisabled.header")
            : t("GeneralEMP.weHaveMoved")}
        </div>
        <div className={styles.deniedInfo}>
          {isUsaOrCanadaMarket ? (
            <>
              <span>{t("AccessDeniedAsBevDisabled.subheader")}</span>{" "}
              <span>{t("AccessDeniedAsBevDisabled.help")}</span>
            </>
          ) : (
            <a
              className={styles.redirectUrl}
              href="https://www.emp.dealerconnection.com"
            >
              {t("GeneralEMP.clickHere")}
            </a>
          )}
        </div>
      </div>
    );
  }
}

AccessDeniedAsBevDisabled.propTypes = {
  userDetails: PropTypes.shape({
    market: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    changeLanguage: PropTypes.func,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  market: PropTypes.string,
  t: PropTypes.func.isRequired,
};

AccessDeniedAsBevDisabled.defaultProps = {
  market: "",
};

export default withTranslation("emp")(AccessDeniedAsBevDisabled);
